import { useMemo, useState } from "react";
import { hasSuccessfulPaymentRecord } from "../paymentCalculations";

export const useCategoryHistory = ({ formData }) => {
  const [savedMembershipNumber, setSavedMembershipNumber] = useState("");
  const [savedStudentIdCard, setSavedStudentIdCard] = useState(null);
  const [savedStudentIdCardName, setSavedStudentIdCardName] = useState("");
  const [savedStudentIdCardType, setSavedStudentIdCardType] = useState("");
  const [categoriesHistory, setCategoriesHistory] = useState([]);
  const [registrationTypesHistory, setRegistrationTypesHistory] = useState([]);
  const [initialPaidCategoryId, setInitialPaidCategoryId] = useState(null);
  const [initialPaidRegistrationTypeId, setInitialPaidRegistrationTypeId] =
    useState(null);
  const [initialPaidCategoryValue, setInitialPaidCategoryValue] = useState("");
  const [initialPaidRegistrationTypeValue, setInitialPaidRegistrationTypeValue] =
    useState("");

  const isCurrentRegistrationPaid =
    formData.paid === true ||
    hasSuccessfulPaymentRecord(formData.payment) ||
    !!formData.paymentId;

  const hasPostPaymentCategoryOrTypeChange =
    isCurrentRegistrationPaid &&
    initialPaidCategoryId !== null &&
    formData.categoryId !== null &&
    (Number(formData.categoryId) !== Number(initialPaidCategoryId) ||
      Number(formData.registrationTypeId || 0) !==
        Number(initialPaidRegistrationTypeId || 0));

  const previousCategoriesHistory = useMemo(() => {
    const base = Array.isArray(categoriesHistory) ? [...categoriesHistory] : [];
    const filtered = base.filter(
      (entry) => Number(entry?.id) !== Number(formData.categoryId)
    );

    const hasInitialInHistory = filtered.some(
      (entry) => Number(entry?.id) === Number(initialPaidCategoryId)
    );

    if (
      formData.paid === true &&
      initialPaidCategoryId !== null &&
      Number(formData.categoryId) !== Number(initialPaidCategoryId) &&
      !hasInitialInHistory
    ) {
      filtered.unshift({
        id: initialPaidCategoryId,
        value: initialPaidCategoryValue || "Previous Category",
      });
    }

    return filtered;
  }, [
    categoriesHistory,
    formData.categoryId,
    formData.paid,
    initialPaidCategoryId,
    initialPaidCategoryValue,
  ]);

  const previousRegistrationTypesHistory = useMemo(() => {
    const base = Array.isArray(registrationTypesHistory)
      ? [...registrationTypesHistory]
      : [];
    const filtered = base.filter(
      (entry) => Number(entry?.id) !== Number(formData.registrationTypeId)
    );

    const hasInitialInHistory = filtered.some(
      (entry) => Number(entry?.id) === Number(initialPaidRegistrationTypeId)
    );

    if (
      formData.paid === true &&
      initialPaidRegistrationTypeId !== null &&
      Number(formData.registrationTypeId || 0) !==
        Number(initialPaidRegistrationTypeId || 0) &&
      !hasInitialInHistory
    ) {
      filtered.unshift({
        id: initialPaidRegistrationTypeId,
        value:
          initialPaidRegistrationTypeValue || "Previous Registration Type",
      });
    }

    return filtered;
  }, [
    registrationTypesHistory,
    formData.registrationTypeId,
    formData.paid,
    initialPaidRegistrationTypeId,
    initialPaidRegistrationTypeValue,
  ]);

  const effectiveCategoriesHistory = useMemo(() => {
    const base = [...previousCategoriesHistory];
    if (formData.paid === true && formData.category) {
      base.push({ id: formData.categoryId, value: formData.category });
    }
    return base;
  }, [
    previousCategoriesHistory,
    formData.paid,
    formData.category,
    formData.categoryId,
  ]);

  const effectiveRegistrationTypesHistory = useMemo(() => {
    const base = [...previousRegistrationTypesHistory];
    if (formData.paid === true && formData.registrationType) {
      base.push({
        id: formData.registrationTypeId,
        value: formData.registrationType,
      });
    }
    return base;
  }, [
    previousRegistrationTypesHistory,
    formData.paid,
    formData.registrationType,
    formData.registrationTypeId,
  ]);

  return {
    savedMembershipNumber,
    setSavedMembershipNumber,
    savedStudentIdCard,
    setSavedStudentIdCard,
    savedStudentIdCardName,
    setSavedStudentIdCardName,
    savedStudentIdCardType,
    setSavedStudentIdCardType,
    categoriesHistory,
    setCategoriesHistory,
    registrationTypesHistory,
    setRegistrationTypesHistory,
    initialPaidCategoryId,
    setInitialPaidCategoryId,
    initialPaidRegistrationTypeId,
    setInitialPaidRegistrationTypeId,
    initialPaidCategoryValue,
    setInitialPaidCategoryValue,
    initialPaidRegistrationTypeValue,
    setInitialPaidRegistrationTypeValue,
    isCurrentRegistrationPaid,
    hasPostPaymentCategoryOrTypeChange,
    previousCategoriesHistory,
    previousRegistrationTypesHistory,
    effectiveCategoriesHistory,
    effectiveRegistrationTypesHistory,
  };
};
